import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import isNull from 'lodash/isNull';
import styled from 'styled-components';
import Toggle from 'react-toggle';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import ItunesCategories from './itunescategories';
import ItunesLanguages from './ituneslanguages';
import LimitWarning from '../../../../components/LimitWarning';
import Loading from '../../../../components/Loading';
import { APP_HOMEPAGE_URL } from '../../../../config';
import { RowDivision, DivisionLabel } from '../shared/styled-components';
import styles from '../shared/styles';
import Colors from '../../../../styles/colors';
import { BaseButton, HigherPlanTag } from '../../../../styles/styled';
import {
  canUserAccessFeature,
  getUsageCurrent,
  getUsageLimit,
} from '../../../../helpers/userinfoHelper';

class OtherSettings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      itunesCategory: [],
      podcastShow: false,
    };

    this.onItunesCategoryChange = this.onItunesCategoryChange.bind(this);
    this.onItunesLanguageChange = this.onItunesLanguageChange.bind(this);
  }

  componentDidMount() {
    const { podcast } = this.props;
    const { show, itunesCategory } = podcast;
    if (show) {
      this.setState({
        itunesCategory,
      });
    }
  }

  onItunesCategoryChange(index) {
    return e => {
      const input = e.target.value;
      const { itunesCategory } = this.state;
      itunesCategory[index] = input;

      if (isEmpty(itunesCategory[index])) {
        itunesCategory.splice(index, 1);
      }

      this.setState(
        {
          itunesCategory,
        },
        () => {
          this.props.onChange('itunesCategory', itunesCategory);
        }
      );
    };
  }

  onItunesLanguageChange(e) {
    const itunesLanguage = e.target.value || 'en';
    this.setState({ itunesLanguage }, () => {
      this.props.onChange('itunesLanguage', itunesLanguage);
    });
  }

  renderPodcastActions() {
    const {
      startProcessingPodcast,
      doneProcessingPodcast,
      podcastFeedVersion,
      onUpdatePodcast,
    } = this.props.podcast;

    if (startProcessingPodcast && !doneProcessingPodcast) {
      return (
        <FeedStatus>
          <Loading
            text="Submitting feed information"
            type="circle"
            align="left"
            size={30}
            fontSize={1.6}
            color="#727981"
            fill="#727981"
          />
        </FeedStatus>
      );
    }

    return (
      <CreateFeedButton onClick={onUpdatePodcast}>
        {(podcastFeedVersion && 'Save Edited Podcast Feed') || 'Create Podcast Feed'}
      </CreateFeedButton>
    );
  }

  renderLimitWarning() {
    const message =
      'You have reached the maximum rss feeds allowed in your plan. Upgrade for additional podcast feeds.';
    return <LimitWarning message={message} onClickUpgrade={this.props.onClickUpgrade} />;
  }

  renderPodcastInput() {
    const { podcastShow } = this.state;
    const { soundcastId, podcast, onChange } = this.props;
    const {
      itunesExplicit,
      itunesTitle,
      itunesOwner,
      itunesHost,
      itunesLanguage,
      autoSubmitPodcast,
      podcastFeedVersion,
    } = podcast;

    const { itunesCategory = [] } = this.state;
    const [itunesCategory1 = '', itunesCategory2 = '', itunesCategory3 = ''] = itunesCategory;

    if (!podcastShow) {
      return null;
    }

    const currentPodcastFeeds = getUsageCurrent('podcast_feeds');
    const allowedPodcastFeeds = getUsageLimit('ALLOWED_PODCAST_FEEDS');
    const limited = isNull(podcastFeedVersion) && currentPodcastFeeds >= allowedPodcastFeeds;
    const submitOnBehalf = canUserAccessFeature('SOUNDCAST_FEED_SUBMIT_ONBEHALF');

    return (
      <React.Fragment>
        <div style={styles.podcastRssFeed}>
          {limited && this.renderLimitWarning()}
          <InputGroup>
            <InputLabel className="no-margin">Your Podcast RSS feed URL</InputLabel>
            <div>
              <a
                target="__blank"
                href={`${APP_HOMEPAGE_URL}/rss/${soundcastId}`}
                style={{ color: Colors.mainOrange }}
                className="text-large font-weight-600">
                {`${APP_HOMEPAGE_URL}/rss/${soundcastId}`}
              </a>
            </div>
          </InputGroup>
          <InputGroup>
            <InputLabel>
              Podcast Submission
              <div className="text-medium font-weight-400">
                The first option sets Soundwise as the owner of the feed. If you want to access the
                Apple Podcasts and Spotify dashboards for your podcast, or plan to submit the feed
                to more aggregators yourself, please choose the self-submit option.
              </div>
            </InputLabel>
            <RadioButtonGroup
              name="podcast submission"
              defaultSelected={autoSubmitPodcast}
              onChange={(e, value) => {
                onChange('autoSubmitPodcast', value);
              }}>
              <RadioButton
                value={true}
                label={
                  <span>
                    Submit the feed to Apple podcasts & Spotify for me{' '}
                    {!submitOnBehalf && <HigherPlanTag className="margin-one-left" />}
                  </span>
                }
                labelStyle={styles.podcastTitleText}
                style={styles.radioButton}
                disabled={!submitOnBehalf}
              />
              <RadioButton
                value={false}
                label="I'll submit it myself"
                labelStyle={styles.podcastTitleText}
                style={styles.radioButton}
              />
            </RadioButtonGroup>
          </InputGroup>
          <InputGroup className="no-margin">
            <InputLabel>Podcast Feed Owner</InputLabel>
            <InputText
              type="email"
              onChange={e => onChange('itunesOwner', e.target.value)}
              value={autoSubmitPodcast ? 'support@mysoundwise.com' : itunesOwner}
              disabled={autoSubmitPodcast}
              readOnly={autoSubmitPodcast}
            />
          </InputGroup>
        </div>
        <div style={styles.podcastRssFeed}>
          <InputGroup>
            <InputLabel>Podcast Title</InputLabel>
            <InputText
              type="text"
              style={styles.inputTitle}
              placeholder={''}
              onChange={e => onChange('itunesTitle', e.target.value)}
              value={itunesTitle}
            />
          </InputGroup>
          <InputGroup>
            <InputLabel>Podcast Host Name</InputLabel>
            <InputText
              type="text"
              style={styles.inputTitle}
              placeholder={''}
              onChange={e => onChange('itunesHost', e.target.value)}
              value={itunesHost}
            />
          </InputGroup>
          <InputGroup>
            <InputLabel>Podcast Language</InputLabel>
            <ItunesLanguages value={itunesLanguage} onChange={this.onItunesLanguageChange} />
          </InputGroup>
          <InputGroup>
            <InputLabel className="no-margin">The material contains explicit language</InputLabel>
            <RadioButtonGroup
              name="Contains explicit language"
              defaultSelected={itunesExplicit}
              onChange={(e, value) => onChange('itunesExplicit', value)}
              style={{ paddingTop: 10 }}>
              <RadioButton
                value={true}
                label="Yes"
                labelStyle={styles.podcastTitleText}
                style={styles.radioButton}
              />
              <RadioButton
                value={false}
                label="No"
                labelStyle={styles.podcastTitleText}
                style={styles.radioButton}
              />
            </RadioButtonGroup>
          </InputGroup>
          <InputGroup>
            <InputLabel>
              iTunes Category 1 <span style={styles.inputLabelRequire}>*</span>
            </InputLabel>
            <ItunesCategories value={itunesCategory1} onChange={this.onItunesCategoryChange(0)} />
          </InputGroup>
          <InputGroup>
            <InputLabel>iTunes Category 2</InputLabel>
            <ItunesCategories value={itunesCategory2} onChange={this.onItunesCategoryChange(1)} />
          </InputGroup>
          <InputGroup>
            <InputLabel>iTunes Category 3</InputLabel>
            <ItunesCategories value={itunesCategory3} onChange={this.onItunesCategoryChange(2)} />
          </InputGroup>
          {this.renderPodcastActions()}
        </div>
      </React.Fragment>
    );
  }

  render() {
    const {
      showTimeStamps,
      showSubscriberCount,
      disableComment,
      showTrackListOnLandingPage,
      enableToggleTrackListOnLandingPage,
      podcast,
      onChange,
      onFeatureNotAllowed,
      enableFaqOnLandingPage,
      enableRatings,
      disableSignup,
      showListenCount,
    } = this.props;
    const { podcastFeedVersion, allowed, onPodcastNotAllowed } = podcast;
    const { podcastShow } = this.state;

    const settings = [
      {
        id: 'disableComment',
        key: 'disableComment',
        value: disableComment,
        title: 'Disable comments and likes',
        disabled: false,
        showWhen: true,
      },
      {
        id: 'showTrackListOnLandingPage',
        key: 'showTrackListOnLandingPage',
        value: showTrackListOnLandingPage,
        title: 'Show track list on soundcast landing page',
        disabled: !enableToggleTrackListOnLandingPage
          // this is necessary to be able to enable the option after downgrading to an earlier version of the plan
          && (showTrackListOnLandingPage || enableToggleTrackListOnLandingPage),
        showWhen: true,
      },
      {
        id: 'publication',
        key: 'showTimeStamps',
        value: showTimeStamps,
        title: 'Show track publication dates',
        disabled: false,
        showWhen: true,
      },
      {
        id: 'subcribercount',
        key: 'showSubscriberCount',
        value: showSubscriberCount,
        title: 'Show subscriber count',
        disabled: false,
        showWhen: true,
      },
      {
        id: 'listeningcount',
        key: 'showListenCount',
        value: showListenCount,
        title: 'Show listening count',
        disabled: false,
        showWhen: true,
      },
      {
        id: 'enableFaqOnLandingPage',
        key: 'enableFaqOnLandingPage',
        value: enableFaqOnLandingPage,
        title: 
          <span>
            {'Show standard FAQs on landing page (See example '}
            <a style={{ textDecoration: 'underline' }} 
              href="https://mysoundwise.com/soundcasts/1604540772115s" target="_blank">
              here
            </a>
            {')'}
          </span>,
        disabled: false,
        showWhen: true,
      },
      {
        id: 'enableRatings',
        key: 'enableRatings',
        value: enableRatings,
        title: 'Enable ratings',
        disabled: false,
        showWhen: true,
      },
      {
        id: 'disableSignup',
        key: 'disableSignup',
        value: disableSignup,
        title: 'Disable non-payment signup',
        disabled: false,
        showWhen: canUserAccessFeature('NON_PAYMENT_ACCESS_LINK'),
      },
      {
        id: 'publication',
        key: 'podcast',
        static: true,
        value: podcastShow,
        title: podcastFeedVersion ? 'Edit the podcast feed' : 'Create a podcast feed',
        disabled: false,
        showWhen: podcast.show,
      },
    ].filter(setting => setting.showWhen);

    if (isEmpty(settings)) {
      return null;
    }

    return (
      <RowDivision className="row">
        <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
          <DivisionLabel>Other Settings</DivisionLabel>
          <SettingsItem>
            {settings.map((setting, index) => {
              return (
                <div className="settings" key={`other-settings-${index}`}>
                  <Toggle
                    className="toggle-green"
                    id={`${setting.id}-status`}
                    aria-labelledby={`${setting.id}-label`}
                    checked={setting.value}
                    disabled={setting.disabled}
                    onChange={() => {
                      if (setting.static) {
                        if (!allowed) {
                          return onPodcastNotAllowed();
                        }

                        return this.setState({
                          podcastShow: !podcastShow,
                        });
                      }

                      onChange(setting.key, !setting.value);
                    }}
                  />
                  <span id={`${setting.id}-label`} style={styles.toggleStatusLabel}>
                    {setting.title} 
                    {setting.disabled && <HigherPlanTag className="margin-one-left btn" 
                        onClick={() => onFeatureNotAllowed()}
                    />}
                  </span>
                </div>
              );
            })}
          </SettingsItem>
          <PodcastSection>
            <MuiThemeProvider>{this.renderPodcastInput()}</MuiThemeProvider>
          </PodcastSection>
        </div>
      </RowDivision>
    );
  }
}

const InputGroup = styled.div`
  margin-bottom: 15px;
`;

const InputLabel = styled.div`
  font-size: ${({ fontSize }) => (fontSize ? fontSize : '1.6rem')};
  font-weight: 700;
  margin: 0px 0px 10px;
`;

const InputText = styled.input`
  &[type='text'],
  &[type='email'] {
    font-size: 1.6rem;
    border-radius: 4px;
    margin-bottom: 0px;
  }
`;

const SettingsItem = styled.div`
  .settings {
    display: flex;
    align-items: flex-start;
    padding-bottom: 10px;

    &:last-child {
      padding-bottom: 0;
    }
  }
`;

const PodcastSection = styled.div`
  padding-top: 20px;
`;

const CreateFeedButton = styled(BaseButton)`
  font-size: 1.6rem;
`;

const FeedStatus = styled.div`
  text-align: left;
  padding-top: 10px;
`;

OtherSettings.propTypes = {
  soundcastId: PropTypes.string,
  showTimeStamps: PropTypes.bool,
  showSubscriberCount: PropTypes.bool,
  showListenCount: PropTypes.bool,
  disableComment: PropTypes.bool,
  showTrackListOnLandingPage: PropTypes.bool,
  enableToggleTrackListOnLandingPage: PropTypes.bool,
  enableFaqOnLandingPage: PropTypes.bool,
  enableRatings: PropTypes.bool,
  disableSignup: PropTypes.bool,
  podcast: PropTypes.object,
  onChange: PropTypes.func,
  onFeatureNotAllowed: PropTypes.func,
};

OtherSettings.defaultProps = {
  soundcastId: '',
  showTimeStamps: true,
  showSubscriberCount: false,
  showListenCount: true,
  disableComment: false,
  showTrackListOnLandingPage: true,
  enableToggleTrackListOnLandingPage: false,
  enableFaqOnLandingPage: true,
  enableRatings: false,
  disableSignup: false,
  onFeatureNotAllowed: () => {},
  podcast: {
    show: false,
    allowed: false,
    itunesExplicit: false,
    itunesImage: '',
    itunesCategory: [],
    itunesTitle: '',
    itunesOwner: '',
    itunesHost: '',
    itunesLanguage: 'en',
    autoSubmitPodcast: false,
    podcastFeedVersion: '',
    onUpdatePodcast: () => {},
    onPodcastNotAllowed: () => {},
    cropperHandler: () => {},
    startProcessingPodcast: false,
    doneProcessingPodcast: false,
  },
  onChange: () => {},
};

export default OtherSettings;
